export const FETCH_BUCKET_ID_REQUEST = 'FETCH_BUCKET_ID_REQUEST'
export const FETCH_BUCKET_ID_SUCCESS = 'FETCH_BUCKET_ID_SUCCESS'
export const FETCH_BUCKET_ID_FALIURE = 'FETCH_BUCKET_ID_FALIURE'
